<template>
  <modal :show="show" @close="close">
    <div class="modal-header">
      <h3 class="subtitle">{{ options.title }}</h3>
      <button class="btn btn-modal-close close" @click="close(false)">
        <span class="btn-content">
          <i class="btn-icon icon-close"></i> <span class="label">Close</span>
        </span>
      </button>
    </div>
    <div class="modal-body" v-html="options.description"></div>
    <div class="modal-footer">
      <button
        class="button-primary button-primary--muted-gray"
        @click="close(true)"
      >
        <span class="button-primary__icon icon icon--arrow-right-hair"></span>
        <span class="button-primary__label">{{ options.buttonLabel }}</span>
      </button>
      <button
        v-if="secondAction"
        class="button-primary button-primary"
        @click="closeWithSecondAction()"
      >
        <span class="button-primary__icon icon icon--arrow-right-hair"></span>
        <span class="button-primary__label">{{
          options.secondButtonLabel
        }}</span>
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from './Modal';

export default {
  name: 'commonModal',
  props: ['show', 'options', 'actionButton', 'secondAction'],
  components: {
    Modal
  },
  methods: {
    close(value) {
      if (value && this.actionButton) {
        this.$emit('close', 1);
      } else {
        this.$emit('close', false);
      }
    },
    closeWithSecondAction() {
      this.$emit('close', 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-header {
  border: none;
  padding: 20px 40px;
  min-height: 16.42857px;
  background: #70747d;

  .close {
    margin-top: -2px;
    display: flex;
    margin-top: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;

    @media (min-width: 1300px) {
      width: 60px;
      height: 60px;
    }
  }

  .subtitle {
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 0px;
    color: #fff;
    font-weight: bold;

    @media (min-width: 1300px) {
      font-size: 22px;
      line-height: 26px;
    }
  }
}

.modal-body {
  position: relative;
  padding: 40px;
}

.modal-footer {
  padding: 20px 40px;
  background: #f5f5f5;
}

.form-container-buttonbar .col .btn,
.form-container-buttonbar .col > :not(.btn),
.form-container-buttonbar .col > :not(.btn) * {
  flex: 1 auto;
  display: flex;
}

.button-primary {
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
}

.btn-modal-close {
  display: flex;
  z-index: 10;
  margin-top: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;

  @media (min-width: 1300px) {
    width: 60px;
    height: 60px;
  }

  &,
  &.active,
  &:active,
  &:focus,
  &:hover,
  .is-clickable:hover & {
    color: #000;
    background-color: transparent;
    border-color: transparent;
  }

  &.active .btn-icon,
  &:active .btn-icon,
  &:hover .btn-icon,
  .is-clickable:hover & .btn-icon {
    color: #d5001c;
    background-color: transparent;
    border-color: transparent;
  }

  .icon-close {
    color: #ffffff;
    background-color: transparent;
    border-color: transparent;
    width: 30px;
    height: 30px;
    border-width: 2px;
    margin-right: -34px;
    font-size: 16px;

    &::before {
      content: '';
      display: block;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      position: relative;
    }

    @media (min-width: 1300px) {
      margin-right: 0;
    }
  }

  .label {
    display: none;
  }
}

.btn-icon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  font-family: pag-iconfont;
  font-size: 25px;
  margin: auto !important;
}

.icon-arrow-right-thin:before {
  content: '';
}

.label {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  white-space: normal;
  margin: 0;
  font-weight: 400;
  line-height: 20px;
  padding-left: 42px;
  color: #000;

  @media (min-width: 760px) {
    font-size: 18px;
    line-height: 22px;
  }

  @media (min-width: 1300px) {
    padding-left: 54px;
  }
}
</style>
